import React from 'react';
import './App.css';
import title from './Images/title.png';
import discord from './Images/discord.webp';
import kofi from './Images/kofi.webp';
import FooterCarousel from './footercarousel';

function App() {
  return (
    <div className="app-container">
      <div className="hero-section">
        <div className="hero-content">
          <img src={title} className="title" alt="Title" />
        </div>

        <div className="top-nav">
          <div className="nav-links">
            <div
              className="nav-item"
              onClick={() => window.location.href = 'https://discord.gg/CN3bysZSqT'}
            >
              <img src={discord} className="nav-icon" alt="Discord" />
              <span>Discord</span>
            </div>
            <div
              className="nav-item"
              onClick={() => window.location.href = 'https://ko-fi.com/thecogwheelsmp'}
            >
              <img src={kofi} className="nav-icon" alt="Ko-fi" />
              <span>Donate</span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-section">
        <h2 className="slogan">"99 Problems, but cogwheels aren't one of them"</h2>
        <div className="carousel-wrapper">
          <FooterCarousel />
        </div>
      </div>


      <a href="https://discord.gg/CN3bysZSqT" className="join-banner">
        Join and get whitelisted today!
      </a>
    </div>
  );
}

export default App;
